import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../../store/userSlice";

export default function TableNotes({
  titles = ["Sl No.", "Description", "Action"],
  allNotes = [],
  setAllNotes,
  setData,
}) {
  const dispatch = useDispatch();
  const [deletedArrayList, SetDeletedArrayList] = useState([]);
  const handleInputChange = (id, value) => {
    const updatedNote = allNotes.map((data) => {
      if (data?.id == id) {
        return { ...data, description: value };
      }
      return data;
    });
    setAllNotes(updatedNote);
  };

  const handleDelete = (id) => {
    if (allNotes.length <= 1) {
      return dispatch(
        setAppError({
          msg: "Atleast one note is needed.",
        })
      );
    }
    const updatedTemplate = allNotes?.filter((item) => item.id != id);
    allNotes.filter((data) => {
      if (data?.id == id) {
        if (data?.type !== "new") {
          SetDeletedArrayList((prev) => [...prev, { notes_id: data.id }]);
        }
      }
    });
    setAllNotes(updatedTemplate);
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      notes_delete: deletedArrayList,
    }));
  }, [deletedArrayList]);

  console.log(deletedArrayList, "deleted arraylist");

  return (
    <>
      <div className="p-5 overflow-x-auto ">
        <div
          className={`grid justify-items-center items-center grid-cols-table-3 auto-cols-min gap-5 p-6 bg-white  w-full min-w-fit  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}

          {allNotes.length <= 0 && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}
          {allNotes?.map((note, index) => (
            <React.Fragment key={note?.id}>
              <p>{Number(index) + 1}</p>

              <textarea
                className="textarea textarea-sm textarea-bordered w-full textTransformNone"
                type="text"
                defaultValue={note?.description}
                required
                onChange={(e) =>
                  handleInputChange(note?.id, String(e.target.value))
                }
                placeholder="Enter Description"
              />
              <div className="flex gap-3 min-w-fit ">
                <button
                  type="button"
                  onClick={() => handleDelete(note?.id)}
                  className="p-1 px-2 rounded-md ring-1 ring-slate-300"
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
              </div>

              <hr className="border-[1.5px] border-slate-100  w-full col-span-3" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
